import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useCapacityBlockGroups() {
  return useQuery({
    queryKey: ["capacity-block-groups"],
    queryFn: () => api.listCapacityBlockGroups(),
  });
}

export function useCbgMachines(cbgId: number) {
  return useQuery({
    queryKey: ["cbg-machines", cbgId],
    queryFn: () => api.listCbgMachines(cbgId),
    enabled: cbgId > 0,
  });
}

export function useStartMachine() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ cbgId, machineId }: { cbgId: number; machineId: number }) =>
      api.startCbgMachine(cbgId, machineId),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ["cbg-machines", variables.cbgId] });
      void queryClient.invalidateQueries({ queryKey: ["capacity-block-groups"] });
    },
  });
}

export function useStopCbgMachine() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ cbgId, machineId }: { cbgId: number; machineId: number }) =>
      api.stopCbgMachine(cbgId, machineId),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ["cbg-machines", variables.cbgId] });
      void queryClient.invalidateQueries({ queryKey: ["capacity-block-groups"] });
    },
  });
}

export function useSyncCbgs() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.syncCbgs(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["capacity-block-groups"] });
    },
  });
}
